<script setup>
import { useFiltersScroll } from './useFiltersScroll';

const { handleButtonClick } = useFiltersScroll({ direction: 'down' });
</script>

<template>
  <div
    class="filtersScrollBtn filtersScrollBtn--down filtersScrollBtn--visible"
    @click="handleButtonClick"
  >
    <div class="filtersScrollBtn__arrows" />
  </div>
</template>
